import { ChartStyle, DonutChartWidgetPayload } from './shared-dtos-donut-widget';

const SCANNED_PALETTE = [
  'var(--green-teal-chart-400)',
  'var(--purple-chart-050)',
  'var(--blue-chart-500)',
  'var(--blue-chart-050)',
  'var(--teal-chart-400)',
  'var(--blue-chart-400)',
];

const BREAKDOWN_PALETTE = [
  'var(--blue-chart-500)',
  'var(--blue-chart-050)',
  'var(--purple-chart-050)',
  'var(--green-teal-chart-400)',
];

const palettes = {
  scanned: SCANNED_PALETTE,
  breakdown: BREAKDOWN_PALETTE,
};

interface Item {
  type: string | number;
  count: number;
}

export function makeDonutChartPayload(
  items: Item[],
  palette: keyof typeof palettes = 'scanned'
): DonutChartWidgetPayload {
  const paletteArray = palettes[palette];
  return {
    donutChart: {
      data: {
        slices: items.map(({ type, count }) => ({ id: type.toString(), value: count })),
      },
      config: {
        label: '',
        chartStyle: ChartStyle.RISK_MANAGEMENT,
        tooltipType: 'horizontal',
        showTooltips: true,
        labelTextMultiline: true,
        slices: items.map(({ type }, index) => ({
          id: type.toString(),
          label: '',
          color: paletteArray[index % paletteArray.length],
        })),
      },
    },
  };
}
